import React from 'react'
import { Icon, Button } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './Message.css'

const Message = props => {
  const classNames = ['Message']
  let icon = 'info'

  if(props.error) {
    classNames.push('is-error')
    icon = 'close'
  }

  if(props.success) {
    classNames.push('is-success')
    icon = 'check'
  }

  if(props.task) {
    classNames.push('is-task')
    icon = 'menu'
  }

  return (
    <div className={classNames.join(' ')} style={props.style}>
      <div className="Message-icon">
        <Icon name={props.icon || icon} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ paddingRight: '4rem' }}>
          {props.title &&
            <div className="Message-title">
              <b>{props.title}</b>
            </div>
          }

          {props.children}
        </div>

        {props.button &&
          <Button {...props.button} />
        }
      </div>
    </div>
  )
}

export default Message
